import { render, staticRenderFns } from "./Lbutton.vue?vue&type=template&id=1e084dd0&scoped=true&"
import script from "./Lbutton.vue?vue&type=script&lang=js&"
export * from "./Lbutton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e084dd0",
  null
  
)

export default component.exports